import { render, staticRenderFns } from "./o-hero-item.vue?vue&type=template&id=80457a9c&"
import script from "./o-hero-item.vue?vue&type=script&lang=js&"
export * from "./o-hero-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports